module.exports = __webpack_public_path__ + "static/media/zilina.06498dfc.jpg";